import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const usePopupModals = (): IGlobalStore['popup_modals'] => {
  return useSelector((store: IReducerStore) => store.global.popup_modals);
};
